import type { AxiosRequestConfig } from 'axios';
import AxiosService from './AxiosService';

export type KicodeBuilder = 'block' | 'codestep' | 'business_app';

export interface LinkedSessionQuery {
  resourcePath: string;
  builder: KicodeBuilder;
  /** Employee id of the current team member. */
  createdBy: string;
}

export interface LinkedSession {
  session_id: string;
  linked_at: string;
  last_active: string;
  created_by: string;
  last_used_by: string;
}

export interface LinkedSessionPage {
  next: string | null;
  previous: string | null;
  results: LinkedSession[];
}

/** Newest-started first. */
const getLinkedSessions = async (
  { resourcePath, builder, createdBy }: LinkedSessionQuery,
  options?: Pick<AxiosRequestConfig, 'signal'>
): Promise<LinkedSessionPage> => {
  const { data } = await AxiosService.get<LinkedSessionPage>(
    '/kicode/sessions',
    {
      params: {
        resource_path: resourcePath,
        kicode_builder: builder,
        created_by: createdBy,
      },
      ...options,
    }
  );
  return data;
};

const KicodeService = Object.freeze({ getLinkedSessions });

export default KicodeService;
